import { render, staticRenderFns } from "./uav-projects.vue?vue&type=template&id=3d587b04&scoped=true"
import script from "./uav-projects.vue?vue&type=script&lang=js"
export * from "./uav-projects.vue?vue&type=script&lang=js"
import style0 from "./uav-projects.vue?vue&type=style&index=0&id=3d587b04&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d587b04",
  null
  
)

export default component.exports